export const enum UserSignInStatechartStateEnum {
  /**
   * Idle state
   */
  idle = 'idle',

  /**
   * Validating user input
   */
  validating = 'validating',

  /**
   * Executing captcha
   */
  executingCaptcha = 'executingCaptcha',

  /**
   * Waiting for user to be signed in on backend side
   */
  signingIn = 'signingIn',
}
